import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { X, Check } from 'lucide-react';


import "../../assets/styles/_common.scss";

const CustomCheckbox = ({ isChecked, toggle, greenVariant }) => (
  <div 
    className={`w-6 h-6 rounded-full border-2 flex items-center justify-center cursor-pointer ${
      greenVariant
        ? isChecked ? 'bg-[#87BF56] border-[#56A535]' : 'border-[#56A535]'
        : isChecked ? 'bg-[#E04C4C] border-[#96323C]' : 'border-[#96323C]'
    }`}
    onClick={toggle}
  >
   {isChecked && (
  greenVariant 
    ? <Check size={16} color="white" />
    : <X size={16} color="white" />
)}
    <input
      type="checkbox"
      className="hidden"
      checked={isChecked}
      onChange={toggle}
    />
  </div>
);

const TaskShareComponent = ({ users }) => {
  const location = useLocation();
  const [checkedStates, setCheckedStates] = useState(
    users.reduce((acc, user) => ({
      ...acc,
      [user.id]: { green: false, red: false }
    }), {})
  );

  const toggleCheckbox = (userId, color) => {
    setCheckedStates(prevState => ({
      ...prevState,
      [userId]: {
        ...prevState[userId],
        [color]: !prevState[userId][color]
      }
    }));
  };

  return (
    <div className="mx-auto w-[264.68px] h-auto bg-[#F6F2EF] border-2 border_dark rounded-lg shadow-md p-[10.3px]">
      <div className="flex justify-between items-center mb-[5.45px]">
        <span className="text-[12px]">Task 1</span>
        {location.pathname !== '/volunteer/requests' && (
          <span className="text-[9px]">Slot left: 5</span>
        )}
      </div>

      {location.pathname !== '/volunteer/requests' && (
        <p className="text-[9px] w-[90%] mb-1">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </p>
      )}

      <ul>
        {users.map((user) => (
          <li key={user.id} className="flex justify-between items-center py-2 border-b">
            <div className='flex items-center'>
              <img
                src={user.image}
                alt={user.name}
                className="w-[30px] h-[30px] rounded-full mr-4"
              />
              <span className="text-[12px] mr-[15.18px] font_ovo">{user.name}</span>
            </div>

            <div className="flex items-center mr-[9.29px]">
              <CustomCheckbox 
                isChecked={checkedStates[user.id].green}
                toggle={() => toggleCheckbox(user.id, 'green')}
                greenVariant={true}
              />
              <div className="ml-2">
                <CustomCheckbox 
                  isChecked={checkedStates[user.id].red}
                  toggle={() => toggleCheckbox(user.id, 'red')}
                  greenVariant={false}
                />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TaskShareComponent;
